import {Component} from '@angular/core';
import { Angulartics2GoogleAnalytics } from 'angulartics2';

@Component({
    selector: 'root',
    template: require('./root.component.html'),
})

export class RootComponent {
        constructor(angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics) {

        }
}



// WEBPACK FOOTER //
// ./src/app/components/root/root.component.ts